import { useLang } from "../context/LanguageContext";
import { SITE } from "../data/content";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      className="relative bg-ink-deeper border-t border-parchment-faint py-12 paper-grain"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <p className="font-serif text-lg text-parchment">
          {t(SITE.name.en, SITE.name.he)}
          <span className="text-four-yellow">.</span>
        </p>
        <p className="text-xs tracking-widest uppercase text-parchment-dusk text-center">
          {t(`© ${year} · Lev Kazaryan`, `© ${year} · לב קזריאן`)}
        </p>
        <p className="text-xs tracking-widest uppercase text-parchment-dusk italic">
          {t("structure over motivation", "מבנה על פני מוטיבציה")}
        </p>
      </div>
    </footer>
  );
}
